// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileFeed-cls1___5b6b504f733a392a244","cls2":"ProfileFeed-cls2___c6df010f0adda97e11a ProfileFeed-cls1___5b6b504f733a392a244"};